<template lang='pug'>
  v-card.draggable(v-if="userHasFF" :class="{ 'highlight': highligth }")
      v-container(fluid).pa-2
        v-layout(align-center justify-space-between)
          v-layout(align-center)
            v-icon(small color="#F7883E").move drag_indicator
            span.card-title {{cardTitle}}
          v-layout(align-center justify-end)
            v-btn(v-if="action" class="card-action" small @click="returnCardActionFunction") {{action}}
            v-icon(color="#F7883E" @click="changeDescriptionView").clickable {{expandDescription ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
      contact-information-v2(
        v-show="expandDescription"
        :ref="`container-${card.card_id}`"
        :card="card"
        :fields="card.fields"
        :isNewAddress="isNewAddress"
        v-on="$listeners"
        :field-value-error-types="fieldValueErrorTypes"
        :field-value-error-messages="fieldValueErrorMessages"
      )
</template>
<script>
import { mapGetters } from 'vuex';
import ContactInformationV2 from '../ContactInformationV2';

export default {
  name: 'DraggableCard',
  props: {
    cardTitle: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
    card: {
      type: Object,
      default: {},
    },
    fieldValueErrorMessages: {
      type: Object,
      default: [],
    },
    fieldValueErrorTypes: {
      type: Array,
      default: {},
    },
    highligth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandDescription: this.card.expand_description || false,
      isNewAddress: false,
    };
  },
  components: {
    ContactInformationV2,
  },
  computed: {
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
    returnCardActionFunction() {
      switch (this.card.card_id) {
        case 'custom_fields':
          return this.showAddCustomField;
        case 'addresses':
          return this.addNewAddress;
        default:
          return ()=>{}
      }
    },
    userHasFF() {
      if (!this.card.feature_flag) return true;
      return this.userHasFeatureFlag(this.card.feature_flag);
    },
  },
  methods: {
    showAddCustomField() {
      this.$emit('add-custom-field');
    },
    addNewAddress() {
      this.isNewAddress = true,
      this.expandDescription = true;
      this.$emit('addressAdd');
    },
    changeDescriptionView() {
      this.isNewAddress = false;
      this.expandDescription = !this.expandDescription;
    },
  },
};
</script>
<style lang="scss" scoped>
.draggable {
  margin: 1.5px;
}
.card-title {
  color: #f7883e;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 19px;
}
.card-action {
  color: #f7883e;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.44px;
  line-height: 16px;
  padding: 0px;
  margin: 0px;
  min-width: 60px;
  background: transparent !important;
  text-transform: none;
}
.clickable {
  cursor: pointer;
}
.move {
  cursor: move;
}
.highlight {
  border-style: dashed;
  border-color: var(--v-primary-base);
  border-width: medium;
}
</style>
